'use strict';

const Loggrr = function() {

  let settings;
  // Default configuration settings
  const defaults = {
    // remoteLogging: false,
    // remoteSettings: {
    //   url: null,
    //   params: null,
    //   success: null,
    //   error: null
    // }
  };

  // Public methods
  const init = (userSettings = defaults) => {
    // Override with user config
    settings = Object.assign(defaults, userSettings);
    window.addEventListener('error', _listener);
  }

  // Private methods
  const _listener = (e) => {
    // Prevent default error behaviour
    e.preventDefault();

    _getDetailedError(e);
    // if (settings.remoteLogging) {
    //   _remoteLogging(e, settings.remoteSettings);
    // }
  }

  const _getDetailedError = (e) => {
    // Retreive the error data
    const data = _errorData(e);

    // Build up help path for stackoverflow
    const helpPath = encodeURI(`https://stackoverflow.com/search?q=${data.error.split(' ').join('+')}`);

    const error = [
      '%cType: ' + data.type,
      'Error: ' + data.error,
      'Stack Trace: ' + data.stackTrace.replace(/\s+/g, ' '),
      'File Name: ' + data.filename,
      'Path: ' + data.path,
      'Line Number: ' + data.line + '\tColumn: ' + data.column,
      'Date: ' + data.datetime,
      'Debug: ' + data.path + ':' + data.line,
      'Help: ' + helpPath
    ].join('\n');

    console.log(error, 'font-weight: bold;color: #c0392b');
  }

  // const _checkStatus = (response) => {
  //   if (response.status >= 200 && response.status < 300) {
  //     return response
  //   } else {
  //     var error = new Error(response.statusText)
  //     error.response = response
  //     throw error
  //   }
  // }

  // function _parseJSON(response) {
  //   return response.json()
  // }

  // function _remoteLogging(e, remoteSettings) {
  //   if (!remoteSettings.url) {
  //     throw 'URL Not provided for remote error logging.';
  //   } else if (remoteSettings.params && typeof remoteSettings.params !== 'object') {
  //     throw 'Invalid paramaters provided for remote error logging.';
  //   }

  //   const url = remoteSettings.url;
  //   const query = Object.keys(params).map((k) => {
  //     return encodeURIComponent(k) + '=' + encodeURIComponent(params[k]);
  //   }).join('&');

  //   fetch(`${remoteSettings.url}remoteSettings.url${query}`, {
  //     method: 'POST',
  //     headers: {
  //       'Accept': 'application/json',
  //       'Content-Type': 'application/json'
  //     },
  //     body: JSON.stringify(_errorData(e))
  //   }).then(_checkStatus)
  //     .then(_parseJSON)
  //     .then((data) => remoteSettings.success(data))
  //     .catch((error) => remoteSettings.error(error))
  // }

  const _errorData = (e) => {
    const filename = e.filename.lastIndexOf('/');
    return {
      type: e.type,
      path: e.filename,
      filename: e.filename.substring(1 + filename),
      line: e.lineno,
      column: e.colno,
      error: e.message,
      stackTrace: ((e.error) ? e.error.stack.toString().replace(/(\r\n|\n|\r)/gm, '') : ''),
      datetime: new Date().toString()
    }
  }

  return {
    init
  };
};

module.exports =  Loggrr();



/** WEBPACK FOOTER **
 ** ./src/loggrr.js
 **/